// extracted by mini-css-extract-plugin
export var container = "_a4-0";
export var error = "_a4-9";
export var label = "_a4-5";
export var light = "_a4-6";
export var md = "_a4-3";
export var sm = "_a4-2";
export var thin = "_a4-8";
export var thinBold = "_a4-7";
export var vertical = "_a4-4";
export var xs = "_a4-1";